var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0H10.75C11.2188 0 11.6875 0.3125 11.875 0.75C12.0625 1.21875 12 1.75 11.6562 2.09375L8.5 5.625V11C8.5 11.4062 8.28125 11.75 7.9375 11.9062C7.59375 12.0625 7.1875 12.0312 6.875 11.8125L4.875 10.3125C4.625 10.125 4.5 9.84375 4.5 9.5V5.625L1.3125 2.09375C0.96875 1.71875 0.90625 1.21875 1.09375 0.75C1.28125 0.3125 1.75 0 2.25 0ZM12 10H16C16.5312 10 17 10.4688 17 11C17 11.5625 16.5312 12 16 12H12C11.4375 12 11 11.5625 11 11C11 10.4688 11.4375 10 12 10ZM11 6C11 5.46875 11.4375 5 12 5H16C16.5312 5 17 5.46875 17 6C17 6.5625 16.5312 7 16 7H12C11.4375 7 11 6.5625 11 6ZM14 0H16C16.5312 0 17 0.46875 17 1C17 1.5625 16.5312 2 16 2H14C13.4375 2 13 1.5625 13 1C13 0.46875 13.4375 0 14 0Z",
    fill: "#525252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.1db8e96abff5658e99564fe439684d0b.svg";
export { ForwardRef as ReactComponent };